<template>
  <v-container>
    <v-row class="align-center justify-center">
      <v-col cols="12" md="12" align-self="center">
        <div id="chart-percentage"></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Highcharts from "highcharts"
import Exporting from 'highcharts/modules/exporting'
import Accessibility from "highcharts/modules/accessibility";
Accessibility(Highcharts);
Exporting(Highcharts)
export default {
  props: ['percentageSeries','text','firstYear','lastYear'],
  name: "PercentageChart",
  data(){
    return{
      chartRendered: undefined,
    }
  },
  mounted() { this.dataSource() },
  watch: {
    percentageSeries(){
      if(this.percentageSeries){
        this.dataSource()
      }
    }
  },
  methods: {
    async dataSource(){
      let chart = document.getElementById('chart-percentage')
      if(this.percentageSeries){
        this.chartNew(this.percentageSeries)
        chart.style.visibility = 'visible'
        chart.style.display = 'block'
      } else {
        chart.style.visibility = 'hidden'
        chart.style.display = 'none'
      }
      this.$emit('chartRenderComplete', this.chartRendered);
    },
    async chartNew(series) {
      this.chartRendered = Highcharts.chart('chart-percentage', {
        chart: {
          type: 'area',
          zoomType: 'x',
          backgroundColor: this.$vuetify.theme.themes.dark.primary.darken1,
        },
        title: { text: null },
        subtitle: { text: null },
        credits: {
          enabled: false,
          href: 'http://www.simepar.br/',
          text:'by: SIMEPAR',
          style:{ color: '#FFFFFF'}
        },
        exporting: {
          enabled: false,
          filename: this.text,
          chartOptions: {
            title: {
              text: this.text,
              style: {
                color: '#FFFFFF'
              }
            },
          }
        },
        legend: {
          enabled: true,
          itemStyle:{ color: '#FFFFFF' },
          itemHoverStyle: { color: '#979797' },
        },
        xAxis: {
          gridLineWidth: 1,
          gridLineColor:'#2D324F',
          type: 'datetime',
          tickmarkPlacement: 'on',
          labels: {
            style:{ color: '#FFFFFF'}
          },
          title: {
            enabled: false,
            style:{ color: '#FFFFFF'}
          },
          accessibility: {
            description: `De ${this.firstYear} até ${this.lastYear}`,
          },
        },
        yAxis: {
          min: 0,
          max: 100,
          endOnTick: false,
          startOnTick: false,
          gridLineWidth: 1,
          gridLineColor:'#2D324F',
          //tickInterval: 10000,
          labels: {
            format: '{value}',
            style:{ color: '#FFFFFF'}
          },
          title: {
            enabled: true,
            text: 'evolução do uso da terra na bacia (%)',
            style:{ color: '#FFFFFF'}
          },
          accessibility: {
            description: "evolução do uso da terra na bacia (%)",
          },
        },
        tooltip: {
          /*pointFormat: '<span>{series.name}</span>: <b>{point.percentage:.1f}%</b> ({point.y:,.0f} ha)<br/>',*/
          pointFormat: '<span>{series.name}</span>: <b>{point.percentage:.2f}%</b><br/>',
          split: true
        },
        plotOptions: {
          area: {
            stacking: 'percent',
            lineColor: '#ffffff',
            lineWidth: 1,
            marker: {
              lineWidth: 1,
              lineColor: '#ffffff'
            },
/*            accessibility: {
              pointDescriptionFormatter: function (point) {
                function round(x) {
                  return Math.round((x * 100) / 100);
                }
                return (point.index + 1) + ', ' + point.category + ', ' +
                  point.y + ' ha, ' + round(point.percentage) + '%, ' +
                  point.series.name;
              }
            }*/
          }
        },
        series: [...series],
        caption: {
          text: `Gráfico empilhado baseado na área total da bacia - Dados históricos da evolução do uso e cobertura da terra em Porcentagem (%) de ${this.firstYear} até ${this.lastYear}`,
          style: { color: "#FFFFFF" },
        },
      });
    },
  },
}
</script>

<style scoped>

</style>
